import ADMIN_TOOL_OBJECT from '../../models/adminToolSection';
import ROLES from '../../models/roles';
import PRIVILEGES from '../../models/privileges';

class AdminToolSectionController {
  constructor(customerService, adminToolSectionService, localStorageService, $state, $stateParams, navBarService, roleService, contentLoaderService, config, $timeout, $scope) {
    this.customerService = customerService;
    this.$state = $state;
    this.$stateParams = $stateParams;
    this.workflowInProgress = null;
    this.cancelWorkflowId = null;
    this.cancelWorkflowSelection = null;
    this.adminService = adminToolSectionService;
    this.batchId = undefined;
    this.objectId = undefined;
    this.mappingMode = 'all';
    this.cancellingWorkflow = null;
    this.selectedCustomer = undefined;
    this.customerList = [];
    this.localStorageService = localStorageService;
    this.mappingItems = ADMIN_TOOL_OBJECT.mapping;
    this.selectedMapping = this.mappingItems[ 0 ];
    this.dependencies = '';
    this.showAlert = false;
    this.batchMode = 'last';
    this.batchFieldValid = true;
    this.hardReset = null;
    this.pauseService = null;
    this.isOverwriteSelected = false;
    this.peopleWithConflicts = null;
    this.defaultQueue = null;
    this.messages = [];
    this.conflictIds = [];
    this.lastBatch = undefined;
    this.offset = 0;
    this.limit = 200;
    this.total = 0;
    this.batchToolTop = null;
    this.useWorkflow = false;
    this.contentLoaderService = contentLoaderService;
    this.importModeValues = [{label: 'Validate Only', value: 0}, {label: 'Validate and Update', value: 1}, {label: 'Validate and Replace', value: 2}];
    this.defaultImportMode = this.importModeValues[0];
    this.orchestrationEntityList = ADMIN_TOOL_OBJECT.orchestration;
    this.selectedOrchestrationEntityValue = null;
    this.services = [];
    this.orchestrationMode = 'all';
    this.triggerDependencies = false;
    this.selectedOrchestrationEntity = false;
    this.selectedService = 'all';
    this.orchestrationEntityId = '';
    this.orchestrationEntityIdValid = true;
    this.canSubmitOrchestration = false;
    this.canSubmitRemoveMapping = false;
    this.canSubmitResetBatch = true;
    this.canSubmitSubgroupOrchestration = false;
    this.canSubmitPurgeSubgroup = true;
    this.cleverClientId = '';
    this.cleverClientSecret = '';
    this.cleverTestStatus = null;
    this.cleverTestMessage = '';
    this.canTestCleverCredentials = false;
    this.cleverCredentialsConfigured = null;  // null = unknown, true/false once loaded
    this.cleverExistingTestStatus = null;
    this.cleverExistingTestMessage = '';
    this.isTestingExistingCreds = false;
    this.includeAssignedSchools = 'false';
    this.orgOrchestration = undefined;
    this.userOrchestration = undefined;
    this.sectionOrchestration = undefined;
    this.queueMessages = [];
    this.alertConfig = {
      type:'success',
      msg:''
    };
    this.pausedServices = 0;
    this.updatedServices = 0;
    this.getServices();
    this.fetchQueueMessages();
    this.deleteEntityList = ADMIN_TOOL_OBJECT.deleteEntites;
    this.canSubmitDeleteEntity = false;
    this.selectedDeleteEntity = false;
    this.deleteSourceSystemId = '';
    this.userPrivileges = roleService.getRoleFieldValue('privileges');
    this.privileges = PRIVILEGES;
    this.navBarService = navBarService;
    this.$timeout = $timeout;
    this._cleverClearTimeout = null;
    $scope.$on('$destroy', () => {
      if (this._cleverClearTimeout) {
        this.$timeout.cancel(this._cleverClearTimeout);
      }
    });
    this.selectedImportMode = null;
    if ($stateParams.customer) {
      this.selectedCustomer = $stateParams.customer;
      navBarService.setActiveTab($state.current.name);
    }
    this.config = config;
  }

  isSuperAdmin() {
    return parseInt(this.localStorageService.get('role')) === ROLES.SUPER_ADMIN;
  }

  getCustomers(searchQuery) {
    this.selectedCustomer = null;
    this.lastBatch = undefined;
    return this.customerService.getCustomers(0, 500, searchQuery, this.isSuperAdmin() ,false)
      .then((results) => {
        if (results.data.content && results.data.content.length === 1){
          const customer = results.data.content[ 0 ];
          if (customer) {
            this.orgOrchestration = customer.orchestrateData;
            this.userOrchestration = customer.orchestrateData;
            this.sectionOrchestration = customer.orchestrateData;
            this.useWorkflow = customer.useWorkflow;
            this.defaultImportMode = this.importModeValues.find(i => i.value === customer.importMode);
            this.getLastBatch();
          }
          if(this.selectedTab === 6) {
            this.getConflictingSourcedIds();
          }
        }
        return results.data.content;
      });
  }


  removeMapping(){
    this.canSubmitRemoveMapping = false;
    const removeMappingConfirmText = 'Are you sure you want to remove mapping of the selected customer?';
    if (confirm(removeMappingConfirmText)) {

      if(this.mappingMode === 'all'){
        this.adminService.removeMapping(this.selectedCustomer.id, this.selectedMapping)
          .then(this.onSuccess.bind(this, 'Customer entity mapping removed successfully!'), this.onFailure.bind(this, 'Customer entity mapping remove failed!'));
      }else{
        const objectId = this.objectId.trim();
        if(objectId) {
          this.adminService.removeMapping(this.selectedCustomer.id, this.selectedMapping, objectId)
            .then(this.onSuccess.bind(this, 'Customer entity mapping removed successfully!'), this.onFailure.bind(this, 'Customer entity mapping remove failed!'));
        }
      }
    }
  }

  triggerOrchestration () {
    if (this.selectedOrchestrationEntityValue && this.selectedOrchestrationEntityValue.value === 'connected') {
      if (this.selectedCustomer) {
        this.adminService.retryCedUserLicenses(this.selectedCustomer.id).then(res => {
          if (res && res.data && res.data.workflowId) {
            this.onSuccess('Workflow triggered successfully!');
          } else {
            this.onFailure('Workflow trigger failed!');
          }
        }, this.onFailure.bind(this, 'Workflow trigger failed!'));
      }
    } else {
      const confirmText = 'Orchestration is turned OFF for this customer.  Are you sure you want to proceed?';
      if (this.selectedCustomer && (this.selectedCustomer.orchestrateData || !this.selectedCustomer.orchestrateData && confirm(confirmText))) {
        this.canSubmitOrchestration = false;
        if(this.orchestrationMode === 'all'){
          this.adminService.triggerOrchestration(this.selectedCustomer.id, this.selectedOrchestrationEntity, this.triggerDependencies).then(this.onSuccess.bind(this, 'Orchestration triggered successfully!'), this.onFailure.bind(this, 'Orchestration trigger failed!'));
        } else if(this.orchestrationMode === 'FAILED'){
          this.adminService.triggerOrchestration(this.selectedCustomer.id, this.selectedOrchestrationEntity, this.triggerDependencies, '', this.orchestrationMode).then(this.onSuccess.bind(this, 'Orchestration triggered successfully!'), this.onFailure.bind(this, 'Orchestration trigger failed!'));
        }
        else {
          const entityId = this.orchestrationEntityId.trim();
          this.orchestrationEntityIdValid = (/[A-Za-z0-9]/g).test(entityId);
          if(this.orchestrationEntityIdValid) {
            this.adminService.triggerOrchestration(this.selectedCustomer.id, this.selectedOrchestrationEntity, this.triggerDependencies, entityId).then(this.onSuccess.bind(this, 'Orchestration triggered successfully!'), this.onFailure.bind(this, 'Orchestration trigger failed!'));
          }
        }
      }
    }
  }

  triggerSubgroupOrchestration() {
    const confirmText = 'Orchestration is turned OFF for this customer.  Are you sure you want to proceed?';
    if (this.selectedCustomer && (this.selectedCustomer.orchestrateData || !this.selectedCustomer.orchestrateData && confirm(confirmText))) {
      this.canSubmitSubgroupOrchestration = false;
      this.adminService.triggerSubgroupOrchestration(this.selectedCustomer.id)
        .then(this.onSuccess.bind(this, 'Subgroup orchestration triggered successfully!'), this.onFailure.bind(this, 'Subgroup orchestration trigger failed!'))
        .finally(() => {
          this.canSubmitSubgroupOrchestration = true;
        });
    }
  }

  triggerPurgeSubgroupData() {
    const confirmText = 'WARNING: This will PERMANENTLY DELETE ALL subgroup data for this customer.\n\nThis action is IRREVERSIBLE and CANNOT be undone.\n\nAre you ABSOLUTELY SURE you want to proceed?';
    if (this.selectedCustomer && confirm(confirmText)) {
      this.canSubmitPurgeSubgroup = false;
      this.adminService.triggerSubgroupOrchestration(this.selectedCustomer.id, 'purge')
        .then(this.onSuccess.bind(this, 'Subgroup data purged successfully!'), this.onFailure.bind(this, 'Subgroup data purge failed!'))
        .finally(() => {
          this.canSubmitPurgeSubgroup = true;
        });
    }
  }

  onSelectedCustomer () {
    this.defaultImportMode = this.selectedCustomer && this.importModeValues.find(i => i.value === this.selectedCustomer.importMode);
    if(this.selectedImportMode && this.defaultImportMode !== this.selectedImportMode){
      this.defaultImportMode = this.selectedImportMode;
    }
    if (this.orgOrchestration === undefined) {
      this.orgOrchestration = this.selectedCustomer && this.selectedCustomer.orchestrateData;
    }
    if (this.userOrchestration === undefined) {
      this.userOrchestration = this.selectedCustomer && this.selectedCustomer.orchestrateData;
    }
    if (this.sectionOrchestration === undefined) {
      this.sectionOrchestration = this.selectedCustomer && this.selectedCustomer.orchestrateData;
    }
    this.useWorkflow = this.selectedCustomer &&  this.selectedCustomer.useWorkflow;
    this.getLastBatch();
  }

  getLastBatch (force = false) {
    if (this.lastBatch === undefined || force || this.lastBatch && this.lastBatch.customerId !== this.selectedCustomer.id) {
      if (this.selectedCustomer && this.selectedCustomer.id) {
        this.lastBatch = null;
        this.adminService.getLastBatch(this.selectedCustomer.id).then((res) => {
          if (res && res.data) {
            this.lastBatch = res.data;
            this.resetSelectedValues();
            if (this.lastBatch) {
              this.canSubmitResetBatch = this.lastBatch.workflowStatus === 'COMPLETE' || this.lastBatch.workflowStatus === 'FAILED' || this.lastBatch.workflowStatus === 'CANCELLED';
            }
          }
        });
      }
    }
  }

  getServices () {
    this.adminService.getServices().then((res) => {
      if (res && res.data) {
        this.services = res.data.map(({name, queueName, pause}, i) => {
          this.pausedServices +=( (pause ? 0 : 1 )+ i);
          return {
            name,
            queueName,
            pause: pause? true : false,
          };
        });
        this.updatedServices = this.pausedServices;
      }
    });
  }

  changeService() {
    this.updatedServices = 0;
    this.services.forEach(({pause}, i) => {
      this.updatedServices += ((pause ? 0 : 1) + i);
    });
  }
  updateServices () {
    this.adminService.updateServices(this.services).then(() => {
      this.onSuccess.bind(this, `${ this.selectedService || 'all' } service(s) paused successfully`);
      this.getServices();
    }).catch(() => {
      this.onFailure.bind(this, `Failed pausing ${ this.selectedService || 'All' } service(s)`);
    });
  }

  mapCourseProducts() {
    const bigRedButtonWarning = 'Are you sure you want to do the BIG RED BUTTON?';
    if (confirm(bigRedButtonWarning)) {
      this.adminService.mapCourseProducts(this.selectedCustomer.id)
        .then(this.onSuccess.bind(this, 'Mapped Course Products'), this.onFailure.bind(this, 'Mapping Course Products failed!'));
    }
  }

  resetCustomer(){
    const resetCustomerConfirmText = `Are you sure you want to${ this.hardReset === 'true' ? ' hard ' : ' ' }reset selected customer?`;
    if (confirm(resetCustomerConfirmText)) {
      this.adminService.resetCustomer(this.selectedCustomer.id, this.hardReset === 'true')
        .then(this.onSuccess.bind(this, 'Customer reset successfully!'), this.onFailure.bind(this, 'Customer reset failed!'));
    }
  }

  createOneRoster(){
    const createOneRosterConfirmText = 'Are you sure you want to create one roster zip for customer?';
    if (confirm(createOneRosterConfirmText)) {
      this.adminService.createOneRoster(this.selectedCustomer.id)
        .then(this.onSuccess.bind(this, 'Created One Roster for customer successfully!'),
          this.onFailure.bind(this, 'Failed creating One Roster for customer!'));
    }
  }

  overwriteSourcedID(e, cmd) {
    const id = e.target.value;
    switch(id) {
    case 'all': {
      switch(cmd) {
      case 'remove':
        this.conflictIds = [];
        break;
      case 'add':
        this.conflictIds = this.peopleWithConflicts.map((person) => person.id);
        break;
      }
      break;
    }
    default: {
      switch(cmd) {
      case 'remove':
        this.conflictIds = this.conflictIds.filter(a => {
          return a !== parseInt(id);
        });
        break;
      case 'add':
        if (!this.conflictIds.includes(parseInt(id))){
          this.conflictIds.push(parseInt(id));
        }
        break;
      }
      break;
    }
    }
  }

  buildMessages(e, cmd) {
    const messageId = e.target.value;
    switch (messageId) {
    case 'all': {
      switch (cmd) {
      case 'remove':
        this.messages = [];
        break;
      case 'add':
        this.messages = this.queueMessages;
        break;
      }
      break;
    }
    default: {
      switch (cmd) {
      case 'remove':
        this.messages = this.conflictIds.filter(a => {
          return a.MessageId !== (messageId);
        });
        break;
      case 'add':
        if (!this.messages.includes(messageId)){
          this.messages.push(messageId);
        }
        break;
      }
      break;
    }
    }
  }


  getConflictingSourcedIds(){
    if (this.offset === 0)
      this.resetSelectedValues(5);
    if (this.selectedCustomer && this.selectedCustomer.id) {
      this.contentLoaderService.show();
      this.adminService.getConflictingSourcedIds(this.selectedCustomer.id, this.offset, this.limit).then((res) => {

        if (res && res.data) {
          if (this.offset === 0) {
            this.peopleWithConflicts = res.data.rows || [];
          } else {
            this.peopleWithConflicts = this.peopleWithConflicts.concat(res.data.rows);
          }
          this.total = res.data.count;
          this.useWorkflow = res.data.useWorkflow;
        }
      }).finally(() => {
        this.contentLoaderService.hide();
      });
    } else {
      this.isOverwriteSelected = true;
      this.onFailure('Please select Customer');
    }
  }

  overwrite(all = false) {
    if(this.conflictIds.length > 0 || all){
      if (all) {
        this.conflictIds = [];
        this.peopleWithConflicts = [];
      }
      const conflictingPeople = this.peopleWithConflicts.filter((person) => (this.conflictIds.indexOf(person.id) >= 0));
      this.adminService.overwrite(this.selectedCustomer.id, conflictingPeople, all).then(() => {
        this.peopleWithConflicts = this.peopleWithConflicts.filter((person) => !(this.conflictIds.indexOf(person.id) >= 0));
        this.conflictIds = [];
        this.onSuccess('Successfully overwritten sourcedIDs.');
      }).catch((res) => {
        this.onFailure(res.data.error.message);
      });
    }
  }

  updateOrchestration (importMode) {
    if(importMode) this.selectedImportMode = importMode;
    // WHEN ORG IS OFF, BOTH USERS AND SECTIONS SHOULD BE OFF
    if (!this.orgOrchestration && (this.userOrchestration || this.sectionOrchestration)) {
      this.orgOrchestration = false;
      this.userOrchestration = false;
      this.sectionOrchestration = false;
    }

    // WHEN USER IS ON ORG SHOULD BE ON
    if (this.userOrchestration) {
      this.orgOrchestration = true;
    }
    // WHEN SECTION IS ON BOTH USERS AND ORGS SHOULD BE ON
    if (this.sectionOrchestration) {
      this.userOrchestration = true;
      this.sectionOrchestration = true;
      this.orgOrchestration = true;
    }
    // FOR VALIDATE ONLY SET ALL ORCH FALSE
    if (this.defaultImportMode.value === 0) {
      this.userOrchestration = false;
      this.sectionOrchestration = false;
      this.orgOrchestration = false;
    }
  }
  resetBatch(){
    const confirmText = 'Orchestration is turned OFF for this customer.  Are you sure you want to proceed?';
    if (this.selectedCustomer && (this.selectedCustomer.orchestrateData || !this.selectedCustomer.orchestrateData && confirm(confirmText))) {
      let batchId = this.batchId || this.lastBatch && this.lastBatch.id;
      if (batchId) {
        batchId = batchId.toString().trim();
        this.batchFieldValid = (/^[0-9]+$/gm).test(batchId);
        const status = this.lastBatch.workflowStatus;
        if (this.batchFieldValid) {
          this.lastBatch.workflowStatus = 'IN_PROGRESS';
          this.adminService.resetBatch(batchId, {
            customerId: this.selectedCustomer.id,
            orgOrchestration: this.orgOrchestration,
            userOrchestration: this.userOrchestration,
            sectionOrchestration: this.sectionOrchestration,
            importMode: this.defaultImportMode.value,
          }).then(() => {
            this.canSubmitResetBatch = false;
            this.onSuccess('Batch reset successfully!');
          }, (res) => {
            this.canSubmitResetBatch = true;
            this.lastBatch.workflowStatus = status;
            if (res && res.status === 404) {
              this.onFailure(`Invalid batch ${batchId}`);
            } else {
              this.onFailure('Batch reset failed!');
            }
          });

        } else {
          this.onFailure('Invalid batch');
        }
      } else {
        this.onFailure('Invalid batch');
      }
    }
  }

  changeCancelWorkflow(val){
    if(val === 0){
      this.cancelWorkflowId = null;
    }
    if (this.cancelWorkflowId && this.cancelWorkflowSelection !== '1'){
      this.cancelWorkflowSelection === '1';
    }
  }

  cancelWorkflow() {
    const confirmText = 'Cancelling Workflow will cancel the current workflow and trigger next in queue.  Are you sure you want to proceed?';
    if (this.selectedCustomer && (this.cancelWorkflowSelection === '0' && this.workflowInProgress && this.workflowInProgress.id || this.cancelWorkflowSelection === '1' && this.cancelWorkflowId) && confirm(confirmText)) {
      this.adminService.cancelWorkflow(this.selectedCustomer.id, this.cancelWorkflowSelection === '0' && this.workflowInProgress && this.workflowInProgress.id || this.cancelWorkflowSelection === '1' && this.cancelWorkflowId, this.cancelWorkflowSelection === '1' && this.cancelWorkflowId ? true : false).then(() => {
        this.canSubmitResetBatch = false;
        this.cancelWorkflowForce = false;
        this.onSuccess('Workflow Cancelled successfully!');
        this.resetSelectedValues(12);
        this.cancelWorkflowSelection = null;
      }, () => {
        this.workflowInProgress = null;
        this.cancelWorkflowForce = false;
        this.onFailure('Workflow Cancel Failed!');
        this.resetSelectedValues(12);
        this.cancelWorkflowSelection = null;
      });
    } else {
      this.onFailure('Please select the workflow to cancel');
    }
  }

  createPAReport(){
    this.adminService.createPAReport(this.selectedCustomer.id, this.includeAssignedSchools === 'true')
      .then(this.onSuccess.bind(this, 'Triggered Product assignment report creation successfully!'),
        this.onCreatePAReportFailure.bind(this));
  }

  onCreatePAReportFailure(errorResponse){
    let errorMsg = '';
    if (errorResponse.status== 409){
      errorMsg = 'Another Product Assignment Report creation request is in progress!';
    }else{
      errorMsg ='Trigger of Product Assignment Report failed!';
    }

    this.alertConfig.type = 'danger';
    this.alertConfig.msg = errorMsg ;
    this.showAlert = true;
  }


  nextPage() {
    this.offset+=this.limit;
    this.getConflictingSourcedIds();
  }

  onFailure(msg){
    window.scrollTo(0,0);
    this.alertConfig.type = 'danger';
    this.alertConfig.msg = msg ;
    this.showAlert = true;
  }


  onSuccess(msg){
    this.alertConfig.type = 'success';
    this.alertConfig.msg = msg;
    this.showAlert = true;
  }

  onSuccessWithLink(msg, link){
    this.alertConfig.type = 'success';
    this.alertConfig.msg = msg;
    this.alertConfig.link = link;
    this.showAlert = true;
  }

  closeAlert(){
    this.showAlert = false;
  }
  resetBatchSelectedValues() {
    this.resetSelectedValues(6);
    this.canSubmitOrchestration = false;
    this.canSubmitRemoveMapping = false;
    this.canSubmitResetBatch = false;
    this.orgOrchestration = this.selectedCustomer && this.selectedCustomer.orchestrateData;
    this.userOrchestration = this.selectedCustomer && this.selectedCustomer.orchestrateData;
    this.sectionOrchestration = this.selectedCustomer && this.selectedCustomer.orchestrateData;
    this.getLastBatch(true);
  }

  resetSelectedValues(index){
    this.selectedImportMode = null;
    this.selectedMapping = '';
    this.batchId = '';
    this.batchMode = 'last';
    this.defaultQueue = null;
    this.messages = [];
    this.selectedService = 'all';
    this.peopleWithConflicts = null;
    this.conflictIds = [];
    this.showAlert = false;
    this.batchFieldValid = true;
    this.orchestrationMode = 'all';
    this.pauseService = null;
    this.selectedOrchestrationEntity = false;
    this.orchestrationEntityId = '';
    this.orchestrationEntityIdValid = true;
    this.offset = 0;
    this.mappingMode = 'all';
    this.objectId = '';
    this.dependencies = '';
    this.canSubmitOrchestration = false;
    this.canSubmitRemoveMapping = false;
    this.canSubmitDeleteEntity = false;
    this.canSubmitSubgroupOrchestration = false;
    this.deleteSourceSystemId = '';
    this.selectedDeleteEntity = '';
    this.selectedTab = index;
    if (index === 16) {
      this.canSubmitSubgroupOrchestration = true;
    }
    if (index === 18) {
      this.checkCleverCredentialsStatus();
      this.cleverExistingTestStatus = null;
      this.cleverExistingTestMessage = '';
    }
    if (index === 12) {
      this.adminService.getInProcessForwardableWorkflows(this.selectedCustomer.id).then((res) => {
        this.workflowInProgress = res && res.data && res.data.inProgess && res.data.inProgess[0] || null;
        this.cancellingWorkflow = res && res.data && res.data.cancelling && res.data.cancelling[0] || null;
      }).catch(() => {
        this.workflowInProgress = null;
        this.cancellingWorkflow = null;
      });
    }
  }

  fetchQueueMessages() {
    this.adminService.getMessages().then((res) => {
      if (res && res.data) {
        this.queueMessages = res.data.Messages.map((message) => {
          message.Body = JSON.parse(message.Body);
          return message;
        });
      }
    });
  }

  changeBatchModeSelection(){
    if (this.batchMode === 'last' && !this.batchId) {
      this.getLastBatch(true);
    } else {
      this.batchMode = '';
      this.canSubmitResetBatch = this.batchId ? true : false;
    }
  }

  changeOrchestrationModeSelection() {
    this.canSubmitOrchestration = true;
    this.orchestrationEntityIdValid = true;
    let entity = ADMIN_TOOL_OBJECT.orchestration.filter((a) => a.value === this.selectedOrchestrationEntity);
    if (entity.length) {
      this.dependencies = entity[ 0 ].dependencies;
      this.triggerDependencies = entity[ 0 ].value === 'section';
      this.selectedOrchestrationEntityValue = entity[ 0 ];
    }
    if(this.orchestrationMode === 'all'){
      this.orchestrationEntityId = '';
    }
  }

  changeMappingModeSelection(){
    this.canSubmitRemoveMapping = true;
    if(this.mappingMode === 'all'){
      this.objectId = '';
    }
  }

  replayMessages (all = false) {
    let messagesToReplay = all ? this.queueMessages :  this.queueMessages.filter((a) => this.messages.includes(a.MessageId));
    messagesToReplay = messagesToReplay.map((a) => {
      a.Body = JSON.stringify(a.Body);
      return a;
    });
    this.adminService.replayMessages(messagesToReplay).then(() => {
      this.messages = [];
      this.queueMessages = [];
    }).catch(() => {
      this.onFailure('failed replay queue');
      this.fetchQueueMessages();
    });
  }

  purgeMessages(all = false) {
    let messagesToPurge = all ? this.queueMessages : this.queueMessages.filter((a) => this.messages.includes(a.MessageId));
    messagesToPurge = messagesToPurge.map((a) => {
      a.Body = JSON.stringify(a.Body);
      return a;
    });
    this.adminService.purgeMessages(messagesToPurge).then(() => {
      this.messages = [];
      this.queueMessages = [];
    }).catch(() => {
      this.onFailure('failed purging queue');
      this.fetchQueueMessages();
    });
  }

  enableRemoveMapping(){
    return this.canSubmitRemoveMapping && this.selectedCustomer && this.selectedMapping;
  }

  enableTriggerOrchestration(){
    return this.canSubmitOrchestration && this.selectedCustomer && this.selectedOrchestrationEntity;
  }

  enableTriggerSubgroupOrchestration(){
    return this.canSubmitSubgroupOrchestration && this.selectedCustomer && this.selectedCustomer.id;
  }

  enableTriggerPurgeSubgroupData(){
    return this.canSubmitPurgeSubgroup && this.selectedCustomer && this.selectedCustomer.id;
  }

  isLastBatchInProgress () {
    return this.lastBatch && (this.lastBatch.workflowStatus !== 'COMPLETE' && this.lastBatch.workflowStatus !== 'FAILED' && this.lastBatch.workflowStatus !== 'CANCELLED');
  }
  enableResetBatch () {
    return this.selectedCustomer && !this.isLastBatchInProgress() && (this.canSubmitResetBatch || this.batchMode === 'last');
  }

  enableProductAssignmentReport(){
    return this.selectedCustomer;
  }

  showDependenciesOption(){
    return this.dependencies && ( this.orchestrationEntityId || this.orchestrationMode === 'FAILED');
  }

  changeDeleteEntitySelection(){
    this.canSubmitDeleteEntity = true;
    this.deleteSourceSystemId = '';
    let entity = ADMIN_TOOL_OBJECT.deleteEntites.filter((a) => a.value === this.selectedDeleteEntity);
    if (entity.length) {
      this.selectedDeleteEntity = entity[ 0 ].value;
    }
  }
  changeDeleteSourcedId() {
    this.canSubmitDeleteEntity = true;
  }
  enableDeleteEntity(){
    return this.canSubmitDeleteEntity && this.selectedCustomer && this.selectedDeleteEntity && this.deleteSourceSystemId;
  }
  deleteEntity(){
    this.canSubmitDeleteEntity = false;
    const deleteEntityConfirmText = 'Are you sure you want to delete selected entity of the selected customer?';
    if (confirm(deleteEntityConfirmText)) {
      this.adminService.deleteEntity(this.selectedCustomer.id, this.selectedDeleteEntity, this.deleteSourceSystemId)
        .then(this.onSuccess.bind(this, 'Customer entity deleted successfully!'), this.onFailure.bind(this, 'Record already deleted or does not exist!'));
    }
  }

  forceSftpBatchTrigger() {
    this.adminService.forceSftpBatchTrigger(this.selectedCustomer.id)
      .then(res => {
        if (res.status === 204) {
          this.onSuccess('No files waiting on customer directory');
        } else {
          this.onSuccessWithLink('Batch started!', {
            href: `${this.config.dataBrowser}/batches/${res.data.batchId}`,
            text: 'View on DataBrowser'
          });
        }
      })
      .catch(res => this.onFailure(`Something went wrong starting the batch, status: ${res.status}`));
  }

  onCleverCredentialsChange() {
    const hasClientId = this.cleverClientId && this.cleverClientId.trim().length > 0;
    const hasClientSecret = this.cleverClientSecret && this.cleverClientSecret.trim().length > 0;
    this.canTestCleverCredentials = hasClientId && hasClientSecret;
    this.cleverTestStatus = null;
    this.cleverTestMessage = '';
  }

  testCleverCredentials() {
    if (!this.canTestCleverCredentials) return;
    
    this.cleverTestStatus = 'testing';
    this.cleverTestMessage = 'Testing and saving credentials...';
    this.canTestCleverCredentials = false;
    
    // Single unified call that tests and saves
    this.adminService.saveCredentials('clever', {
      clientId: this.cleverClientId,
      clientSecret: this.cleverClientSecret
    })
      .then(() => {
        this.cleverTestStatus = 'success';
        this.cleverTestMessage = 'Credentials validated and saved successfully!';
        this.cleverCredentialsConfigured = true;
        // Clear fields after successful save
        this._cleverClearTimeout = this.$timeout(() => {
          this.cleverClientId = '';
          this.cleverClientSecret = '';
          this.cleverTestStatus = null;
          this.cleverTestMessage = '';
          this.canTestCleverCredentials = false;
        }, 2000);
      })
      .catch(err => {
        this.cleverTestStatus = 'error';
        this.cleverTestMessage = `Failed: ${(err.data && err.data.error) || (err.data && err.data.message) || 'Invalid credentials'}`;
        // Re-enable the button so the user can retry
        this.canTestCleverCredentials = true;
      });
  }

  checkCleverCredentialsStatus() {
    this.cleverCredentialsConfigured = null;
    this.adminService.getCredentialsStatus('clever')
      .then(res => {
        this.cleverCredentialsConfigured = res && res.data && res.data.configured;
      })
      .catch(() => {
        this.cleverCredentialsConfigured = false;
      });
  }

  testExistingCleverCredentials() {
    if (this.isTestingExistingCreds) return;
    this.isTestingExistingCreds = true;
    this.cleverExistingTestStatus = 'testing';
    this.cleverExistingTestMessage = 'Testing existing credentials...';

    this.adminService.testExistingCredentials('clever')
      .then(() => {
        this.cleverExistingTestStatus = 'success';
        this.cleverExistingTestMessage = 'Existing credentials are valid!';
        this.isTestingExistingCreds = false;
      })
      .catch(err => {
        this.cleverExistingTestStatus = 'error';
        const status = err && err.status;
        if (status === 404) {
          this.cleverExistingTestMessage = 'No credentials found. Please save credentials first.';
        } else {
          this.cleverExistingTestMessage = `Failed: ${(err.data && err.data.error) || 'Credentials are invalid'}`;
        }
        this.isTestingExistingCreds = false;
      });
  }
}

AdminToolSectionController.$inject = ['customerService', 'adminToolSectionService', 'localStorageService', '$state', '$stateParams', 'navBarService', 'roleService', 'contentLoaderService', 'config', '$timeout', '$scope'];

export default AdminToolSectionController;



// WEBPACK FOOTER //
// ./app/components/adminToolSection/adminToolSection.controller.js